import axios from 'axios';
// import { display } from 'html2canvas/dist/types/css/property-descriptors/display';
import { update } from 'lodash';
import { status } from 'nprogress';
// config
import { HOST_API } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API });

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  auth: {
    me: '/api/profile',
    getProfile: '/api/getinfo',
    login: '/api/login',
    forgetPassword: '/api/forgot-password',
    resetPassword: '/api/reset-password',
    resetPasswords: '/api/reset-passwords',
    // register: '/api/auth/register',
  },
  getStats: '/admin/getStats',
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },
  tasks: {
    add: '/api/tasks/add',
    list: '/api/tasks/list',
    edit: '/api/tasks/edit',
    status: '/api/tasks/updatestatus',
    filter: '/api/tasks/getfiltered',
  },
  role: {
    add: '/api/role/add',
    status: '/api/role/status/',

    edit: '/api/role/update/',
    permission: '/api/permission/list/',
    addpermission: '/api/permission/add',
  },
  // customized api
  user: {
    list: '/api/users',
    mobile: '/api/checkmobile',
    creted: '/api/getName/',
    changepass: '/api/passwordlist',
    lists: '/api/users/list',
    student: '/api/student/getbyid/',
    gettrainerid: '/api/getuserbyemail/',
    role: '/api/role/list',
    councellors: '/api/coun',
    getuser: '/api/byid/',
    add: '/api/register',
    edit: '/api/',
    counsellor: '/api/roletype/4',
    status: '/api/status/',
  },
  task: {
    list: '/api/timesheet/list',
    add: '/api/timesheet/create',
    byid: '/api/timesheet/list/',
  },
    application: {
        getall: '/api/apps/getall',
    add: '/api/apps/add',
    delete: '/api/apps/delete/',
    edit: '/api/apps/edit/',
      getAllNotif: '/api/apps/getnotificationall/',
  },
  announcement: {
    getall: '/api/adminanno/getall',
    updatefix:'/api/adminanno/fixannounce',
  delete: '/api/adminanno/delete/',
    sendmails: '/api/adminanno/sendmail',
    attendance: '/api/attendance/lists',
    studentatte: '/api/attendance/studentattendance',
    addholiday: '/api/holidays/add',
    getHolidays: '/api/holidays/data',
    users: '/api/user/',
    add: '/api/adminanno/add',
    getNotif: '/api/adminanno/getnotification/',
    getAllNotif: '/api/adminanno/getnotificationall/',
    trainerlist: '/api/announcement/get/',
    markread: '/api/adminanno/markreadnotification',
    updatestu: '/api/announcement/updateread/',
    traineradd: '/api/announcement/add',
    not: '/api/adminanno/getbyuser/',
    studentnot: '/api/announcement/getnot/',
    studentall: '/api/announcement/getallnot/',
    getstu: '/api/announcement/getstudent/',
    updateall: '/api/adminanno/updateall',
  },
  attendance: {
    list: '/api/attendance/list',
    add: '/api/attendance/add',
  },
  dashboard: {
    count: '/api/switchbatch/dashboard',
    topics: '/api/topics/gettrainers',
    trainer: '/api/switchbatch/studentsbatches',
    course: '/api/switchbatch/getMatrix',
    ongoing: '/api/switchbatch/ongoing',
    studentstatus: '/api/switchbatch/getstatus',
    studentstatuscoun: '/api/switchbatch/getstatuscoun',
    today: '/api/switchbatch/gettodayinterview',
    due: '/api/switchbatch/getdue',
    students: '/api/switchbatch/getstudentdata',
    studentscoun: '/api/switchbatch/getstudentdatacoun',
    users: '/api/switchbatch/usersdata',
    moed: '/api/switchbatch/getbatchmode',
    moedcoun: '/api/switchbatch/getbatchmodecoun',
    batch: '/api/switchbatch/batchdashboard',
    paymentgraph: '/api/switchbatch/getfeedetails',
    paymentgraphcon: '/api/switchbatch/getfeedetailscoun',
  },
  category: {
    list: '/api/category/list',
    edit: '/api/category/update',
    add: '/api/category/add',
    delete: '/api/category',
    status: '/api/category/status/',
  },
  mode: {
    list: '/api/coursemode/list',
    edit: '/api/coursemode/',
    active: '/api/coursemode/activelist',
    getbyid: '/api/coursemode/list/',
    add: '/api/coursemode/add',
    delete: '/api/coursemode',
    status: '/api/coursemode/status/',
  },
  feetype: {
    list: '/api/feetype/list',
    edit: '/api/feetype/',
    add: '/api/feetype/add',
    status: '/api/feetype/status/',
  },
  feeSet: {
    list: '/api/setfee/list',
    edit: '/api/setfee/',
    add: '/api/setfee/add',
    status: '/api/setfee/status/',
    get: '/api/setfee/getbycourse',
  },
  course: {
    list: '/api/course/list',
    active: '/api/course/activelist',
    getbyid: '/api/course/list/',
    edit: '/api/course/update',
    add: '/api/course/add',
    status: '/api/course/status/',
  },
  schedule: {
    list: '/api/schedule/list',
    edit: '/api/schedule/',
    add: '/api/schedule/add',
    status: '/api/schedule/status/',
  },
  duration: {
    list: '/api/duration/list',
    edit: '/api/duration/',
    add: '/api/duration/add',
    status: '/api/duration/status/',
  },
  trainer: {
    individualtrainer: '/api/trainer/getindividual/',
    trainerid: '/api/trainer/gettrainer/',
     assignzoom: '/api/trainer/updatezoom',
    classadd: '/api/class/add',
    completed: '/api/topics/completed',
    isSend: '/api/topics/send',
    gettopic: '/api/topics/getbybatchtrainer',
        gettopicss: '/api/topics/getbybatchtrainers',
    classupdate: '/api/class/update',
    getclass: '/api/class/get',
 listBtachs:"/api/student/listbatchsimple",
    gettopics: '/api/topics/arraylist',
    list: '/api/trainer/list',
    edit: '/api/trainer/update',
    add: '/api/trainer/add',
    getbatch: '/api/trainer/get',
    allbatch: '/api/batch/batchtrainer/',
    status: '/api/trainer/status/',
    performance: '/api/class/perform',
  },
  studymaterial:{
  add: '/api/material/add',
  list: '/api/material/list',
  edit: '/api/material/update',
  },
  mentor: {
    individualmentor: '/api/mentor/getindividual/',
    assignmentor: '/api/student/updatementors',
       assignloc: '/api/student/updateclassloc',
    // trainerid: '/api/trainer/gettrainer/',
    // classadd: '/api/class/add',
    // completed: '/api/topics/completed',
    // isSend: '/api/topics/send',
    // gettopic: '/api/topics/getbybatchtrainer',
    // classupdate: '/api/class/update',
    // getclass: '/api/class/get',

    getstudentsbyid: '/api/mentor/getmentors',
    list: '/api/mentor/list',
    edit: '/api/mentor/update',
    add: '/api/mentor/add',
    // getbatch: '/api/trainer/get',
    // allbatch: '/api/batch/batchtrainer/',
    status: '/api/mentor/status/',
    // performance: '/api/class/perform',
  },
  softskill: {
    add: '/api/softskill/add',
    check: '/api/softskill/check',
    getsoft: '/api/softskill/getbystudent',
    remark: '/api/softskill/giveremark',
    isgiven: '/api/softskill/isgiven',
    send: '/api/softskill/sendemail',
    isDone: '/api/softskill/updateisDone/',
    get: '/api/softskill/get/',
    getsoftskill: '/api/softskill/getAll',
    details: '/api/softskill/getstudentdetails',
    getbyid: '/api/softskill/getbyid',
  },
  assignment: {
    list: '/api/assignment/list',
    reject: '/api/assignment/submit',
    get: '/api/assignment/get/',
    submit: '/api/assignment/isRead',
    getallassignment: '/api/assignment/fetchassignment',
    trainer: '/api/assignment/fetchbytariner',
    ongoingbatch: '/api/assignment/ongoing',
    add: '/api/assignment/add',
    student: '/api/assignment/fetch',
    fetchassignments: '/api/assignment/fetchall',
    send: '/api/assignment/stdassignment/add',
  },
  interview: {
    schedule: '/api/student/scheduleinterview',
    get: '/api/student/getperformance/',
    update: '/api/student/updateinterview',
    updatestatus: '/api/student/updateinterviewstatus',
    feedback: '/api/student/updatefeedback',
  },
  comapny: {
    add: '/api/company/add',
    list: '/api/company/list',
    active: '/api/company/activelist',
    status: '/api/company/status/',
    edit: '/api/company/update',
  },
  qa: {
    add: '/api/qanda/add',
    list: '/api/qanda/list',
    active: '/api/qanda/activelist',
    status: '/api/qanda/status/',
    edit: '/api/qanda/update',
    getbyid: '/api/qanda/getbyid',
  },
  prefloc: {
    add: '/api/prelocation/add',
    list: '/api/prelocation/list',
    active: '/api/prelocation/activelist',
    status: '/api/prelocation/status/',
    edit: '/api/prelocation/update',
  },
  enquiry: {
    list: '/api/enquiry/list',
    counsellor: '/api/enquiry/bycounsellor/',
    edit: '/api/enquiry/',
    add: '/api/enquiry/add',
    filter: '/api/enquiry/filter',
    status: '/api/enquiry/status/',
  },
  outstanding: {
    list: '/api/student/outfilter',
     listcoun: '/api/student/outfiltercoun',
    sendsingle: '/api/student/feeremindertostudent',
  },
   referandearn: {
    list: '/api/referandearn/list',
     listbyid: '/api/referandearn/rewardlist',
     addreward: '/api/referandearn/rewardadd',
     statusreward: '/api/referandearn/updatestatus'
  },
  due: {
    getDue: '/api/student/duestudents',
    getDueCoun: '/api/student/duestudentscoun',
    filter: '/api/student/getduefilter',
    display: '/api/switchbatch/getduestudent',
    displaycoun: '/api/switchbatch/getduestudentcoun',
    sendsingle: '/api/student/sendnotification',
    sendbulkdues: '/api/student/sendbulknotifictaion',
  },
  doubt: {
    checklimit: '/api/doubt/limit',
    add: '/api/doubt/add',
    studentdoubt: '/api/doubt/std/',
    trainerdoubt: '/api/doubt/train/',
    list: '/api/doubt/list',
    reject: '/api/doubt/reject',
    accept: '/api/doubt/accept',
    trainerfeed: '/api/doubt/trainerfeedback',
    studentfeed: '/api/doubt/studentfeedback',
  },
  student: {
     sitbooking :'/api/student/sitbooking',
    updatedoc: '/api/student/checkupdatedoc',
    docreview: '/api/student/docreview',
    addremark: '/api/student/markremarkss',
    getremark: '/api/student/get/remark',
    deleteremark: '/api/student/markremarksdelete',
    countview: '/api/student/studentcounts',
    checkprofile: '/api/student/checkprofile',
    attendanceprofile: '/api/student/checkattendanceprofile',
    makeinactive: '/api/student/statusinactive',
    adddoc: '/api/student/addupdatedoc',
    updateresume: '/api/student/update/resume',
    filteredEnroll: '/api/student/getfilteredstudents',
    updatelinks: '/api/student/updatelinks',
    reschedle: '/api/softskill/reshedule',
    registerfilter: '/api/student/registerfilter',
    deletediscount: '/api/student/deletediscount',
      deleteinstall: '/api/student/deleteinstall',
    discountlist: '/api/student/getdiscountlist/',
    eligibleStudent: '/api/student/activelist',
    filterintervew: '/api/student/filterinterview',
    getlinks: '/api/student/links/',
    addrecite: '/api/enrolled/add',
    refershrecite: '/api/enrolled/refresh',
    checkrecite: '/api/enrolled/check',
    uptoinstall: '/api/enrolled/uptoinstall',
    getActive: '/api/student/activelist',
    getActives: '/api/student/getactive',
    getpaid: '/api/student/feeData',
    getamount: '/api/enrolled/getamount',
    placedstatus: '/api/student/updateplacedstatus',
    getplaced: '/api/student/placedstudent',
    updateplaced: '/api/student/addplacement',
    getreviewdata: '/api/student/getreview',
    details: '/api/assignment/details/',
    getpaymentdetails: '/api/student/getpaymentdetail/',
    getdiscount: '/api/student/getdiscount/',
    getCourse: '/api/subjects/coursewithsubj',
    deletecertificate: '/api/student/deleteCertificate',
    getcertificate: '/api/student/certificate/',
    registerlist: '/api/student/register/list',
    admitedlist: '/api/student/admitedlist/list',
    list: '/api/student/list',
    paymentstatus: '/api/student/installpyment',
    discount: 'api/student/updatediscount',
    updatereview: '/api/student/updatereview',
    edit: '/api/student/',
    joining: '/api/student/addjoining',
    switchbatch: '/api/switchbatch/add',
    addbatchswitch: "/api/switchbatch/addbatches",
    switchproperbatch :"/api/switchbatch/switchbatches",
    fullswitchbatch: '/api/switchbatch/addfull',
     sharebatch: '/api/switchbatch/sharebatch',
    sharebatchs: '/api/switchbatch/sharebatches',
    parswitchbatch: '/api/switchbatch/addpar',
    checkbatchdetails: '/api/switchbatch/checkdetails',
    switchmultiplebatch: '/api/switchbatch/multiple',
    add: '/api/student/add',
      addreward: '/api/student/rewardadd',
    getfee: '/api/student/fee/',
    oldesume: '/api/student/oldresume',
    createfee: '/api/student/createfee',
    updatepayment: '/api/student/updatepayment',
    updatefee: '/api/student/updatefee',
    updateoneInstallment: '/api/student/updateoneinstallment',
    updateInstallment: '/api/student/updateinstallment',
    updateCertificate: '/api/student/updateStudentCertificate',
    status: '/api/student/status/',
    placementready :'/api/student/placementready',
    allot: '/api/student/allotbatch/',
    addbulk: '/api/student/addbulkperformance',
    sendbulk: '/api/student/schedulebulkinterview',
  },
  leads: {
    view: '/api/lead/list',
    update: '/api/lead/',
    saveLeads: '/webhook/save-facebook-leads',
    add: '/webhook/',
    status: '/api/lead/status/',
  },
  job: {
    getall: '/api/jobpost/getall',
    edit: '/api/jobpost/edit',
    apply: '/api/jobpost/apply',
    add: '/api/jobpost/add',
    getAll: '/api/jobpost/getall/',
  },
  zoom: {
    createlink: '/api/zoom/create-zoom-meeting',
    getvideos:'/api/zoom/getvideos',
    updatelink: '/api/zoom/update-zoom-meeting',
    filteredmeet: '/api/zoom/getfilteredzoom',
    statusmeet: '/api/zoom/status-zoom-meeting',
    getstudentbyid: '/api/zoom/getstudent-zoom-meeting',
    joinstudentbyid: '/api/zoom/joinstudent-zoom-meeting',
    verifyJoin:'/api/zoom/verify-zoom-meeting',
  },
    pages: {
    add: '/api/pages/create-pages',
    status: '/api/pages/status/',
    edit: '/api/pages/edit',
    list: '/api/pages/list',
    // addpermission: '/api/permission/add',
  },
  batch: {
    addtrainer: '/api/topics/add',
    active: '/api/batch/listactive',
    getcount: '/api/batch/studentscount',
    getbyid: '/api/batch/list/',
    getbytrainer: '/api/topics/getbybatchtrainer',
    list: '/api/batch/list',
    delete:'/api/batch/deletebatch/',
    getid: '/api/course/subjectsbycourse',
    checkbatch: '/api/batch/checkbatch',
    getstudents: '/api/batch/getstudentsbybatch',
    edit: '/api/batch/',
    add: '/api/batch/add',
    status: '/api/batch/status/',
    trainer: '/api/trainer/gettrainers',
    course: '/api/course/subjectsbycourse',
  },
  experience: {
    list: '/api/experience/list',
    name: '/api/experience/name/',
    edit: '/api/experience/',
    add: '/api/experience/add',
    status: '/api/experience/status/',
  },
  status: {
    list: '/api/feestatus/list',
    edit: '/api/feestatus/status/update/',
    add: '/api/feestatus/add',
    status: '/api/feestatus/status/',
  },
  paymentmode: {
    list: '/api/paymentmode/list',
    edit: '/api/paymentmode/',
    active: '/api/paymentmode/activelist',
    add: '/api/paymentmode/add',
    status: '/api/paymentmode/status/',
  },
    zoomaccount: {
    list: '/api/zoom_account/list',
    edit: '/api/zoom_account/',
    add: '/api/zoom_account/add',
    status: '/api/zoom_account/status/',
  },
  verify: {
    send: '/api/verify/send',
    code: '/api/verify/code',
  },
  active: {
    cate: '/api/category/activelist',
    mode: '/api/coursemode/activelist',
    sub: '/api/subjects/activelist',
    train: '/api/trainer/activelist',
    sche: '/api/schedule/activelist',
    cours: '/api/course/activelist',
  },
  paymentbank: {
    list: '/api/paymentbank/list',
    activelist: 'api/paymentbank/activelist',
    edit: '/api/paymentbank/',
    add: '/api/paymentbank/add',
    status: '/api/paymentbank/status/',
  },
  aboutus: {
    list: '/api/aboutus/list',
    active: '/api/aboutus/actlist',
    edit: '/api/aboutus/',
    add: '/api/aboutus/add',
    status: '/api/aboutus/status/',
  },
  subjects: {
    check: '/api/subjects/checktopic',
    list: '/api/subjects/list',
    edit: '/api/subjects/update',
    add: '/api/subjects/add',
    status: '/api/subjects/status/',
    checktopic: '/api/subjects/gettopics',
  },
};
